import { render, staticRenderFns } from "./TableSongsHead.vue?vue&type=template&id=23cf62eb"
import script from "./TableSongsHead.vue?vue&type=script&lang=js"
export * from "./TableSongsHead.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports